(ns common.schema.entities.aifm-decision.core
  "Common entity-type definition of the AIFM investment decision. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the AIFM decision documents with the calculated fields."
  (:require
   [common.schema.entities.aifm-decision.permissions :as permissions]
   [common.schema.entities.aifm-decision.schema :as aifm-decision]))

(def entity-type-definition
  {:entity-type                  :entity.type/aifm-decision
   :schema                       aifm-decision/schema
   :name                         {:en "AIFM investment decision"}
   :plural                       {:en "AIFM investment decisions"}
   :icon                         :fa-hand-holding-seedling
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
